
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Autocomplete extends Vue {
	@Prop({ type: Array, required: true }) private items!: any[];
	@Prop({ type: String, default: 'mdi-menu-down' }) private appendIcon!: string;
	@Prop({ type: String, default: 'mdi-close-circle-outline' }) private clearIcon!: string;
	@Prop({ type: String, default: '' }) private id!: string;
	@Prop({ type: String, default: 'primary' }) private itemColor!: string;
	@Prop({ type: String, default: '' }) private label!: string;
	@Prop({ type: String, default: '' }) private name!: string;
	@Prop({ type: String, default: '' }) private placeholder!: string;
	@Prop({ type: String, default: '' }) private prefix!: string;
	@Prop({ type: String, default: '' }) private suffix!: string;
	@Prop({ type: [String, Array, Object], default: '' }) private customClass!: string | string[] | object;
	@Prop({ type: [String, Array], default: () => [] }) private errorMessages!: string | string[];
	@Prop({ type: [String, Array], default: () => [] }) private messages!: string | string[];
	@Prop({ type: Boolean, default: false }) private clearable!: boolean;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, default: false }) private multiple!: boolean;
	@Prop({ type: Boolean, default: false }) private noFilter!: boolean;
	@Prop({ type: [Boolean, String], default: false }) private loading!: boolean | string;
	@Prop({ type: Boolean, default: false }) private outlined!: boolean;
	@Prop({ type: [Boolean, String], default: false }) private hideDetails!: boolean | string | undefined;
	@Prop({ type: Object, default: () => ({}) }) private menuProps!: object;
	@Prop({ type: Function, default: undefined }) private filter!: Function | undefined;
	@Prop({ type: [String, Array, Function], default: 'text' }) private itemText!: string | any[] | Function;
	@Prop({ type: [String, Array, Function], default: 'value' }) private itemValue!: string | any[] | Function;
	@Prop({ default: undefined }) private value!: any;
}
